import { render } from "./ActiveRound.vue?vue&type=template&id=a1e5b792&scoped=true"
import script from "./ActiveRound.vue?vue&type=script&lang=js"
export * from "./ActiveRound.vue?vue&type=script&lang=js"

import "./ActiveRound.vue?vue&type=style&index=0&id=a1e5b792&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e5b792"]])

export default __exports__